<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') ||
                  '转库单编号/出库仓库名称/入库仓库名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
                <b-button
                  size="sm"
                  class="ml-2"
                  variant="outline-success"
                  v-if="allow('A')"
                  @click="
                    $emit('openEditDialog', {
                      type: 'add',
                    })
                  "
                >
                  <b-icon-plus></b-icon-plus>
                  {{ $l('INDEX.btn_add') || '新增' }}
                </b-button>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="900px"
      top="10vh"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" label-position="top" size="small">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.Status') || '转库单状态'">
              <dict-select
                filterable
                size="small"
                clearable
                multiple
                v-model="form.stockTransferStatusList"
                :body="{ dictType: 'stockTransferStatus' }"
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_mrpStockTransferNo') || '转库单编号'"
            >
              <el-input
                v-model="form.mrpStockTransferNo"
                clearable
                maxlength="50"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_transferType') || '转库类型'">
              <dict-select
                filterable
                size="small"
                clearable
                v-model="form.transferType"
                :body="{ dictType: 'transferType' }"
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_outWarehouse') || '出库仓库'"
              prop="outWarehouseCode"
            >
              <dict-select
                clearable
                multiple
                v-model="form.outwarehouseCodeList"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                size="small"
                url="/ecom/warehouse/cn/warehouse/select"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_inWarehouse') || '入库仓库'"
              prop="warehouseCode"
            >
              <dict-select
                clearable
                multiple
                v-model="form.inWarehouseCodeList"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                size="small"
                url="/ecom/warehouse/cn/warehouse/select"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('table_label_transferDate') || '转库日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginTransferDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endTransferDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.table_label_created_date') || '创建时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginCreateDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endCreateDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginModifyDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endModifyDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  stockTransferStatusList: ['Y', 'N'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
